<script setup lang="ts">
    import { computed } from 'vue'

    /**
     * Preview for the tools whose input is already a sentence written for the
     * user (`requestConfirm`): it is shown as-is, with no key/value framing.
     */
    const props = defineProps<{
        input?: unknown
    }>()

    const message = computed(() => {
        const input = props.input as { message?: unknown } | undefined
        return typeof input?.message === 'string' ? input.message : ''
    })
</script>

<template>
    <p v-if="message" class="text-12 text-word-3 m-0 mb-xs">
        {{ message }}
    </p>
</template>
